import {
  ON_DOCUMENT_DOWNLOAD,
  ON_MESSAGE_BOX_OPEN,
  ON_MESSAGE_BOX_INVOKE,
  ON_ATTACHED_DOC_INFO,
  ON_SUCCESS_DIALOG_MENU_OK_BUTTON_CLICK,
  ON_VIEWCOPY_DOC_INFO,
  ON_VIWE_DOCUMENT_WEB,
  ON_RECENT_OBJECT_VALUES,
  ON_SEARCH_KEY_REF,
  ON_ROW_SELECTION_CHANGE_RECENT_OBJECTS,
  ON_NEWREVISION_CHANGED,
  ON_NEWREVISION_OBJCON_CHANGED,
  ON_REVISIONSEARCH_ITEM_SELECT,
  ON_CREATE_VIEWCOPY_CHANGED,
  ON_DOCCLASS_CHANGED,
  ON_VIEWREQUIRED_CHANGED,
  ON_VIEWCOPY_UPLOAD_FAILED,
  ON_NEWREVISION_DISABLED,
  ON_DOCUMENT_UPLOAD_FAILED,
  ON_ONEDRIVE_DATALOAD,
  ON_SELECTED_OBJECTS_CHANGED,
  ON_RECENT_OBJECT_SELECTED,
  ON_OBJECTCONNECTION_DATALOAD,
  ON_CHECKIN_DOCUMENT_PROGRESS,
  ON_CHECKIN_PROGRESS_CHANGED,
  ON_DOCDOCFORMATLIST_CHANGED,
  ON_BASIC_DATA_INFO_CHANGED,
  ON_SPINNER_TEXT_CHANGE,
  ON_FILETYPES_CHANGED,
  ON_ONEDRIVE_FILE_TYPE_SELECTED,
  ON_NEWREVISION_INFO_CHANGED,
  ON_TOKEN_FAIL,
  ON_IFS_DOCUMENT_LOAD_CHANGED,
  ON_PROCESS_SUCCESS,
  ON_UPLOAD_ONEDRIVE_FILES,
  ON_UPLOAD_ONEDRIVE_STATUS_CHANGED,
  ON_IFS_USER_LOAD,
  ON_ERROR_MESSAGE_INVOKE,
  ON_CHECKIN_EXISTING_STATUS_CHANGE,
  ON_SERVER_ERROR_MESSAGE_INVOKE,
  ON_EXCEPTION_MESSAGE_INVOKE,
  ON_CHECKIN_EXISTING_DATA_CHANGE,
  ON_WORKING_DOCUMENT_CHANGE,
  ON_WARNING_MESSAGE_INVOKE,
  ON_VIEWCOPYUPLOAD_CHANGE,
  ON_RECENT_OBJECTS_CHANGED,
  ON_RECENT_OBJECTS_DATA_LOAD_STATUS,
  ON_RECENT_OBJECTS_DATA_ERROR_MESSAGE,
  ON_LOGIN_REFRESH_PREACTION,
  ON_LOGIN_REFRESH_PREACTION_INVOKE,
  ON_NEWREVISION_DOC_INFO_CHANGED,
  ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
} from "../constants/actionTypes";
import {
  FAILED_TO_DOWNLOAD,
  ERROR_TYPE,
  WARNING_TYPE,
  SERVER_WARNING_TYPE,
  ERROR_DETAILS,
  SERVER_RESPONSE_ERROR,
  CHECKED_OUT_ALREADY,
  IFS_SERVER_ERROR,
  NO_CONTENT_FOUND,
  CREATE_REVISION_FAILED,
  CREATE_DOCUMENT_FAILED,
  CREATE_VIECOPY_FAILED,
  FAILED_REVISION_INFO,
  FAILED_RECENT_OBJECTS,
  FAILED_OBJECT_COLUMNS,
  NO_LOGICALUNIT_FOUND,
  FAILED_LOGICALUNIT_FOUND,
  NO_DEFAULT_OBJECTS_FOUND,
  CHECK_OUT_WARNING,
  NOT_CHECK_OUT_WARNING,
  NO_REVISION_FOUND,
  VALIDATION_FAILED_ERROR,
  CHECKED_OUT_ALREADY_MESSAGE,
  NO_CLASSFORMAT_FOUND,
  FAILED_TO_GET_CLASSFORMAT,
  UNKOWN_ERROR,
  IFS_TOKEN_EXPIRED,
  CREATE_VIECOPY_FAILED_TITLE,
  DOCUMENT_BASIC_DATA_ERROR,
  DOCUMENT_LOGICAL_UNITS_ERROR,
  RECENT_OBJECT_DATA_ERROR,
  NEW_REVISION_INFO_ERROR,
  CHECKIN_VIEWCOPY
} from "../constants/messageTypes";
import {
  ON_CHECKIN_NEW_PAGE_NAME,
  CHECKIN_NEW_PAGE_NAME,
  DATA_LOAD_STATUS,
  LOGICALUNIT_VALUES,
  CHECKIN_PROCESS_TYPE,
  UPLOADING_FILE,
  INVALID_DOCUMENT,
  FILE_STATE,
  MANDATORY_TYPE,
  DOC_CHECK_IN_TYPE,
  OPERATION_TYPE,
  USER_TOKEN_STATUS,
  DOCUMENT_LOAD_STATUS,
  REFRESH_TOKEN_ACTION,
  MAX_TOKEN_REFRESH,
  RESPONSE_TYPE,
  DEFAULT_REFRESH_TOKEN_PRE_ACTION,
  DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
  TIME_OUT_STATUS_CODE,
} from "../constants/metaData";

import axios from "axios";
import AuthTeams from "../../auth/AuthTeams";
import UserAuth from "../../auth/userAuth";
import CustomerConfig from "../../azure/CustomerConfig";
import { appInsights } from "../../azure/appInsights";
import {
  getETag,
  getValidValue,
  sanitizeFileName,
} from "../../functions/helperMethod";
import { HomeCheckmark16Filled } from "@fluentui/react-icons";
import {
  isValidPlayload,
  isTokenRefreshRequired,
  getUpdatedTokenRefreshPreAction,
  isTokenRefreshFailed,
} from "../../functions/reduxMethod";
import { getApiClient } from "../api/client";

require("dotenv").config();

let subscriptionKey = new CustomerConfig().getSubscriptionKey();
let userAuth = new UserAuth();
export const onCheckinDocuments =
  (
    docTitle,
    docClass,
    docFormat,
    uploadFiles,
    createViewCopy,
    SelectedObjects,
    uploadViewCopyCount,
    viewRequired,
    docReleaseStatus,
    oneDriveDeleteRequired,
    tokenRefreshPreAction,
  ) =>
  async (dispatch) => {
    const tokenResponse = await userAuth.getUserToken(true);
    const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
    if (!tokenOneDrive) {
      dispatch({
        type: ON_TOKEN_FAIL,
        payload: tokenResponse,
      });
      return;
    }

    if (isTokenRefreshFailed(tokenRefreshPreAction)) {
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION,
        payload: {
          retry: 0,
          actionType: REFRESH_TOKEN_ACTION.none,
        },
      });
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
        payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
      });
      let messageBox = {
        type: ERROR_TYPE,
        message: IFS_TOKEN_EXPIRED,
      };
      dispatch({
        type: ON_MESSAGE_BOX_INVOKE,
        payload: messageBox,
      });
      dispatch({
        type: ON_MESSAGE_BOX_OPEN,
        payload: true,
      });
      dispatch({
        type: ON_CHECKIN_DOCUMENT_PROGRESS,
        payload: DOCUMENT_LOAD_STATUS.onError,
      });
      dispatch({
        type: ON_DOCUMENT_DOWNLOAD,
        payload: false,
      });
      return;
    }

    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onCheckinDocuments",
      statusCode: 0,
    };
    try {
      const selectedList = Array.isArray(SelectedObjects) ? SelectedObjects : [];
      const uploadFilesList = Array.isArray(uploadFiles) ? uploadFiles : [];

      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
        timeout: timeout(uploadFilesList),
      });
      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;

      const objConData = [];

      selectedList.forEach((item) => {
        objConData.push({
          luName: item.luName,
          keyRef: item.keyRef,
            updateRevision: "LatestRevision",
          updateRevisionCode: "LatestRevision",
        });
      });

      uploadFilesList.forEach(async (uploadFile) => {
        const docInfo = {
          checkinViewCopy: false,
          docClass: docClass,
          title: docTitle,
          docFormat: docFormat,
          fileData: uploadFile.base64str,
          fileName: sanitizeFileName(uploadFile.name),
          objectConnections: objConData,
          createViewCopy: createViewCopy,
          rollbackRevisionOnFail: viewRequired,
          webUser: new AuthTeams().getEmail(),
          status:
            docReleaseStatus === false
              ? ""
              : uploadViewCopyCount > 0
                ? ""
                : docReleaseStatus,
        };
        if (uploadFilesList.length > 0) {
          dispatch({
            type: ON_CHECKIN_PROGRESS_CHANGED,
            payload: CHECKIN_PROCESS_TYPE.checkin,
          });
          dispatch({
            type: ON_SUCCESS_DIALOG_MENU_OK_BUTTON_CLICK,
            payload: false,
          });

          dispatch({
            type: ON_VIEWCOPY_DOC_INFO,
            payload: null,
          });

          dispatch({
            type: ON_IFS_DOCUMENT_LOAD_CHANGED,
            payload: DATA_LOAD_STATUS.onStart,
          });
          dispatch({
            type: ON_VIEWCOPY_UPLOAD_FAILED,
            payload: false,
          });
          dispatch({
            type: ON_DOCUMENT_UPLOAD_FAILED,
            payload: false,
          });
          dispatch({
            type: ON_CHECKIN_DOCUMENT_PROGRESS,
            payload: DOCUMENT_LOAD_STATUS.onLoading,
          });
          dispatch({
            type: ON_SPINNER_TEXT_CHANGE,
            payload: UPLOADING_FILE,
          });
          dispatch({
            type: ON_DOCUMENT_DOWNLOAD,
            payload: true,
          });
          dispatch({
            type: ON_ONEDRIVE_FILE_TYPE_SELECTED,
            payload: "",
          });
          await authAxio
            .post("/api/DocumentManagement/check-in", docInfo, {
              headers: {
                "Ocp-Apim-Subscription-Key": subscriptionKey,
                "Customer-Key": new AuthTeams().getCustomerKey(),
                "User-Key": new AuthTeams().getUserKey(),
              },
            })
            .then((res) => {
              switch (res.status) {
                case 200:
                  dispatch({
                    type: ON_ATTACHED_DOC_INFO,
                    payload: res.data,
                  });
                  dispatch({
                    type: ON_PROCESS_SUCCESS,
                    payload: true,
                  });
                  dispatch({
                    type: ON_LOGIN_REFRESH_PREACTION,
                    payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
                  });
                  dispatch({
                    type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
                    payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
                  });
                  if (uploadViewCopyCount > 0) {
                    dispatch({
                      type: ON_DOCUMENT_DOWNLOAD,
                      payload: true,
                    });
                    dispatch({
                      type: ON_CHECKIN_DOCUMENT_PROGRESS,
                      payload: DOCUMENT_LOAD_STATUS.onViewCopyUpload,
                    });
                  } else {
                    dispatch({
                      type: ON_DOCUMENT_DOWNLOAD,
                      payload: false,
                    });
                    dispatch({
                      type: ON_CHECKIN_NEW_PAGE_NAME,
                      payload: CHECKIN_NEW_PAGE_NAME.file,
                    });
                    dispatch({
                      type: ON_SUCCESS_DIALOG_MENU_OK_BUTTON_CLICK,
                      payload: true,
                    });
                    dispatch({
                      type: ON_ONEDRIVE_DATALOAD,
                      payload: DATA_LOAD_STATUS.onLoad,
                    });
                    if (oneDriveDeleteRequired) {
                      dispatch({
                        type: ON_CHECKIN_DOCUMENT_PROGRESS,
                        payload: DOCUMENT_LOAD_STATUS.onDeleting,
                      });
                    } else {
                      dispatch({
                        type: ON_CHECKIN_DOCUMENT_PROGRESS,
                        payload: DOCUMENT_LOAD_STATUS.onCompletion,
                      });
                    }
                  }
                  break;
                default:
                  dispatch({
                    type: ON_SUCCESS_DIALOG_MENU_OK_BUTTON_CLICK,
                    payload: false,
                  });
                  let messageBox = {
                    type: ERROR_TYPE,
                    message: IFS_SERVER_ERROR,
                    errorMessage: "",
                    error: null,
                  };
                  appInsightProps.statusCode = res.status;
                  if (res.status === 204) {
                    messageBox.message = `${NO_CONTENT_FOUND}`;
                    appInsights.trackException({
                      error: `${NO_CONTENT_FOUND}`,
                      appInsightProps,
                    });
                  } else if (res.status === 202) {
                    messageBox.message = `${IFS_SERVER_ERROR}`;
                    messageBox.errorMessage =
                      res.data?.errorMessage !== null ? `${res.data}` : "";
                    appInsights.trackException({
                      error:
                        messageBox.errorMessage === ""
                          ? messageBox.errorMessage
                          : `${IFS_SERVER_ERROR}`,
                      appInsightProps,
                    });
                  } else if (res.status === 400) {
                    messageBox.message = `${CREATE_DOCUMENT_FAILED}`;
                    messageBox.errorMessage =
                      res.data !== null ? `${res.data}` : "";
                    appInsights.trackException({
                      error:
                        messageBox.errorMessage === ""
                          ? messageBox.errorMessage
                          : `${CREATE_DOCUMENT_FAILED}`,
                      appInsightProps,
                    });
                  } else {
                    messageBox.message = `${CREATE_DOCUMENT_FAILED}`;
                    messageBox.errorMessage = `Error Code: ${res.status}`;
                    appInsights.trackException({
                      error:
                        messageBox.errorMessage === ""
                          ? messageBox.errorMessage
                          : `${CREATE_DOCUMENT_FAILED}`,
                      appInsightProps,
                    });
                  }

                  dispatch({
                    type: ON_MESSAGE_BOX_INVOKE,
                    payload: messageBox,
                  });
                  dispatch({
                    type: ON_MESSAGE_BOX_OPEN,
                    payload: true,
                  });
                  dispatch({
                    type: ON_VIWE_DOCUMENT_WEB,
                    payload: { text: "", state: false },
                  });
                  dispatch({
                    type: ON_ATTACHED_DOC_INFO,
                    payload: INVALID_DOCUMENT,
                  });
                  dispatch({
                    type: ON_CHECKIN_DOCUMENT_PROGRESS,
                    payload: DOCUMENT_LOAD_STATUS.onError,
                  });
              }
              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION,
                payload: {
                  retry: 0,
                  actionType: REFRESH_TOKEN_ACTION.none,
                },
              });
              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
                payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
              });
            })
            .catch(function (error) {
              console.log(error.toJSON(), "err");
              if (
                isTokenRefreshRequired(
                  error.response,
                  tokenRefreshPreAction,
                  REFRESH_TOKEN_ACTION.checkinNew,
                )
              ) {
                dispatch({
                  type: ON_LOGIN_REFRESH_PREACTION,
                  payload: getUpdatedTokenRefreshPreAction(
                    tokenRefreshPreAction,
                    REFRESH_TOKEN_ACTION.checkinNew,
                  ),
                });
                dispatch({
                  type: ON_IFS_USER_LOAD,
                  payload: USER_TOKEN_STATUS.refresh,
                });
              } else {
                let serverResponseError = {
              response: error.response,
              statusCode: error.response.status,
              error: error.toJSON(),
            };
            dispatch({
              type: ON_SERVER_ERROR_MESSAGE_INVOKE,
              payload: serverResponseError,
            });
                dispatch({
                  type: ON_VIWE_DOCUMENT_WEB,
                  payload: { text: "", state: false },
                });
                dispatch({
                  type: ON_ATTACHED_DOC_INFO,
                  payload: INVALID_DOCUMENT,
                });
                dispatch({
                  type: ON_LOGIN_REFRESH_PREACTION,
                  payload: {
                    retry: 0,
                    actionType: REFRESH_TOKEN_ACTION.none,
                  },
                });
                dispatch({
                  type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
                  payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
                });
                dispatch({
                  type: ON_CHECKIN_DOCUMENT_PROGRESS,
                  payload: DOCUMENT_LOAD_STATUS.onError,
                });
                dispatch({
                  type: ON_DOCUMENT_DOWNLOAD,
                  payload: false,
                });
              }
            });
        }
      });
    } catch (ex) {
      dispatch({
        type: ON_MESSAGE_BOX_INVOKE,
        payload: {
          type: ERROR_TYPE,
          message: CREATE_DOCUMENT_FAILED,
          errorMessage: ex.message,
          error: null,
        },
      });
      dispatch({
        type: ON_MESSAGE_BOX_OPEN,
        payload: true,
      });
      dispatch({
        type: ON_DOCUMENT_UPLOAD_FAILED,
        payload: true,
      });
      dispatch({
        type: ON_CHECKIN_DOCUMENT_PROGRESS,
        payload: DOCUMENT_LOAD_STATUS.onError,
      });
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION,
        payload: {
          retry: 0,
          actionType: REFRESH_TOKEN_ACTION.none,
        },
      });
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
        payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
      });
      dispatch({
        type: ON_CHECKIN_DOCUMENT_PROGRESS,
        payload: DOCUMENT_LOAD_STATUS.onError,
      });
      dispatch({
        type: ON_DOCUMENT_DOWNLOAD,
        payload: false,
      });
      console.log(ex.message, "err");
      appInsightProps.statusCode = 0;
      appInsights.trackException({ error: ex.message, appInsightProps });
    }
  };

export const onCheckinExistingDocument =
  (
    uploadFile,
    deleteRequired = false,
    docReleaseStatus,
    createViewCopy,
    isUploadViewCopy,
    tokenRefreshPreAction = {
      retry: 0,
      actionType: REFRESH_TOKEN_ACTION.none,
      refreshResponse: RESPONSE_TYPE.none,
    },
  ) =>
  async (dispatch) => {
    try {
      dispatch({
        type: ON_PROCESS_SUCCESS,
        payload: false,
      });
      dispatch({
        type: ON_CHECKIN_EXISTING_DATA_CHANGE,
        payload: null,
      });
      const tokenResponse = await userAuth.getUserToken(true);
      const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
      if (!tokenOneDrive) {
        dispatch({
          type: ON_TOKEN_FAIL,
          payload: tokenResponse,
        });
        return;
      }

      if (isTokenRefreshFailed(tokenRefreshPreAction)) {
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION,
          payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
        });
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
          payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
        });

        let messageBox = {
          type: ERROR_TYPE,
          message: IFS_TOKEN_EXPIRED,
        };

        dispatch({
          type: ON_ERROR_MESSAGE_INVOKE,
          payload: messageBox,
        });
        dispatch({
          type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
          payload: DOCUMENT_LOAD_STATUS.onError,
        });
        return;
      }

      let messageBox = {
        type: ERROR_TYPE,
        message: IFS_SERVER_ERROR,
        errorMessage: "",
        error: null,
      };

      let uploadFilesList = getValidValue(uploadFile, null);
      if (uploadFilesList === null) {
        messageBox.errorMessage = VALIDATION_FAILED_ERROR;
        dispatch({
          type: ON_ERROR_MESSAGE_INVOKE,
          payload: messageBox,
        });
        dispatch({
          type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
          payload: DOCUMENT_LOAD_STATUS.onError,
        });
        return;
      }

      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
      });
      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;

      const documentRevision = getValidValue(
        uploadFile?.documentRevision,
        null,
      );
      const oneDriveFile = getValidValue(uploadFile?.oneDriveFile, null);

      const objectConnections = getValidValue(uploadFile?.objectConnection, []);
      let oneDriveFileName = getValidValue(uploadFile?.fileName, null);
      if (oneDriveFileName != null) {
        oneDriveFileName = sanitizeFileName(oneDriveFileName);
      }

      const fileData = uploadFile.fileData;
      const docInfo = {
        checkinViewCopy: false,
        docClass: documentRevision.docClass,
        docNo: documentRevision.docNo,
        docRev: documentRevision.docRev,
        title: encodeURIComponent(documentRevision.Title),
        docFormat: getValidValue(documentRevision.FormatSize, ""),
        docSheet: documentRevision.docSheet,
        fileData: fileData,
        fileName: sanitizeFileName(uploadFile.fileName),
        objectConnections: objectConnections,
        createViewCopy: createViewCopy,
        rollbackRevisionOnFail: false,
        webUser: new AuthTeams().getEmail(),
        status: docReleaseStatus === false ? "" : docReleaseStatus,
      };
      await authAxio
        .post("/api/DocumentManagement/check-in-existing", docInfo, {
          headers: {
            "Ocp-Apim-Subscription-Key": subscriptionKey,
            "Customer-Key": new AuthTeams().getCustomerKey(),
            "User-Key": new AuthTeams().getUserKey(),
          },
        })
        .then((res) => {
          switch (res.status) {
            case 200:
              dispatch({
                type: ON_CHECKIN_EXISTING_DATA_CHANGE,
                payload: res.data,
              });

              const oneDriveUploadFile = {
                docClass: documentRevision.docClass,
                docNo: documentRevision.docNo,
                docSheet: documentRevision.docSheet,
                docRev: documentRevision.docRev,
                docType: documentRevision.DocType,
                fileNo: documentRevision.FileNo,
                title: encodeURIComponent(documentRevision.Title),
                fileExtension: documentRevision.FileExtension ?? documentRevision.fileExtension ?? "",
                state: FILE_STATE.checkedIn,
                fileState: FILE_STATE.checkedIn,
                owner: documentRevision.DocRespName,
                lastActionDate: new Date().toISOString().split("T")[0],
                isDownloaded: true,
                operationType: OPERATION_TYPE.DOWNLOAD,
                documentId: oneDriveFile.id,
              };

              dispatch({
                type: ON_WORKING_DOCUMENT_CHANGE,
                payload: oneDriveUploadFile,
              });

              if (isUploadViewCopy) {
                dispatch({
                  type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                  payload: DOCUMENT_LOAD_STATUS.onViewCopyUpload,
                });
              } else {
                if (deleteRequired) {
                  dispatch({
                    type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                    payload: DOCUMENT_LOAD_STATUS.onDeleting,
                  });
                } else {
                  dispatch({
                    type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                    payload: DOCUMENT_LOAD_STATUS.onCompletion,
                  });
                }
              }
              break;
            case 203:
              let warningMessage = {
                type: SERVER_WARNING_TYPE,
                message: CHECKED_OUT_ALREADY,
                errorMessage: CHECKED_OUT_ALREADY_MESSAGE,
                error: null,
              };
              dispatch({
                type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                payload: DOCUMENT_LOAD_STATUS.onError,
              });

              dispatch({
                type: ON_WARNING_MESSAGE_INVOKE,
                payload: warningMessage,
              });
              break;
            default:
              dispatch({
                type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                payload: DOCUMENT_LOAD_STATUS.onError,
              });

              let responseFailure = {
                response: res,
                statusCode: res.status,
                error: null,
              };
              dispatch({
                type: ON_SERVER_ERROR_MESSAGE_INVOKE,
                payload: responseFailure,
              });
          }
          dispatch({
            type: ON_LOGIN_REFRESH_PREACTION,
            payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
          });
          dispatch({
            type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
            payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
          });
        })
        .catch(function (error) {
          console.log(error.toJSON(), "err");
          if (
            isTokenRefreshRequired(
              error.response,
              tokenRefreshPreAction,
              REFRESH_TOKEN_ACTION.checkinExisting,
            )
          ) {
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: getUpdatedTokenRefreshPreAction(
                tokenRefreshPreAction,
                REFRESH_TOKEN_ACTION.checkinExisting,
              ),
            });
            dispatch({
              type: ON_IFS_USER_LOAD,
              payload: USER_TOKEN_STATUS.refresh,
            });
          } else {
            let serverResponseError = {
              response: error.response,
              statusCode: error.response.status,
              error: error.toJSON(),
            };
            dispatch({
              type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
              payload: DOCUMENT_LOAD_STATUS.onError,
            });
            dispatch({
              type: ON_SERVER_ERROR_MESSAGE_INVOKE,
              payload: serverResponseError,
            });
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
            });
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
              payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
            });
          }
        });
    } catch (ex) {
      console.log(ex.message, "err");
      let errorMessage = {
        message: ex.message,
        showMessageBox: true,
      };

      dispatch({
        type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
        payload: DOCUMENT_LOAD_STATUS.onError,
      });
      dispatch({
        type: ON_EXCEPTION_MESSAGE_INVOKE,
        payload: errorMessage,
      });
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION,
        payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
      });
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
        payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
      });
    }
  };

export const onCheckinNewRevision =
  (
    selectedRevisionItem,
    newRevision,
    newRevisionText,
    uploadFiles,
    createViewCopy,
    newRevisionObjCon,
    uploadViewCopyCount,
    viewRequired,
    docReleaseStatus,
    oneDriveDeleteRequired,
    tokenRefreshPreAction = {
      retry: 0,
      actionType: REFRESH_TOKEN_ACTION.none,
      refreshResponse: RESPONSE_TYPE.none,
    },
  ) =>
  async (dispatch) => {
    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onCheckinNewRevision",
      statusCode: 0,
    };
    try {
      const tokenResponse = await userAuth.getUserToken(true);
      const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
      if (!tokenOneDrive) {
        dispatch({
          type: ON_TOKEN_FAIL,
          payload: tokenResponse,
        });
        return;
      }

      if (isTokenRefreshFailed(tokenRefreshPreAction)) {
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION,
          payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
        });
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
          payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
        });

        let messageBox = {
          type: ERROR_TYPE,
          message: IFS_TOKEN_EXPIRED,
        };

        dispatch({
          type: ON_ERROR_MESSAGE_INVOKE,
          payload: messageBox,
        });
        dispatch({
          type: ON_VIWE_DOCUMENT_WEB,
          payload: { text: "", state: false },
        });
        dispatch({
          type: ON_ATTACHED_DOC_INFO,
          payload: INVALID_DOCUMENT,
        });
        dispatch({
          type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
          payload: DOCUMENT_LOAD_STATUS.onError,
        });
        dispatch({
          type: ON_DOCUMENT_DOWNLOAD,
          payload: false,
        });
        return;
      }

      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
        timeout: timeout(uploadFiles),
      });

      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;

      let uploadFilesList = uploadFiles;
      uploadFilesList.forEach(async (uploadFile) => {
        const docInfo = {
          checkinViewCopy: createViewCopy,
          docClass: selectedRevisionItem.class,
          docNo: selectedRevisionItem.docNo,
          docRev: selectedRevisionItem.docRev,
          docSheet: selectedRevisionItem.sheetNo,
          title: selectedRevisionItem.title,
          docFormat:
            selectedRevisionItem.format == null
              ? ""
              : selectedRevisionItem.format,
          fileData: uploadFile.base64str,
          fileName: sanitizeFileName(uploadFile.name),
          objectConnections: newRevisionObjCon,
          createViewCopy: createViewCopy,
          rollbackRevisionOnFail: viewRequired,
          webUser: new AuthTeams().getEmail(),
          status:
            docReleaseStatus === false
              ? ""
              : uploadViewCopyCount > 0
                ? ""
                : docReleaseStatus,
        };
        const newRevisionObj = {
          documentRevision: docInfo,
          newRevision: newRevision,
          newRevisionText: newRevisionText,
        };
        if (uploadFilesList.length > 0) {
          dispatch({
            type: ON_CHECKIN_PROGRESS_CHANGED,
            payload: CHECKIN_PROCESS_TYPE.checkin,
          });
          dispatch({
            type: ON_SUCCESS_DIALOG_MENU_OK_BUTTON_CLICK,
            payload: false,
          });
          dispatch({
            type: ON_VIEWCOPY_DOC_INFO,
            payload: null,
          });
          dispatch({
            type: ON_IFS_DOCUMENT_LOAD_CHANGED,
            payload: DATA_LOAD_STATUS.onStart,
          });
          dispatch({
            type: ON_VIEWCOPY_UPLOAD_FAILED,
            payload: false,
          });
          dispatch({
            type: ON_DOCUMENT_UPLOAD_FAILED,
            payload: false,
          });
          dispatch({
            type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
            payload: DOCUMENT_LOAD_STATUS.onLoading,
          });
          dispatch({
            type: ON_SPINNER_TEXT_CHANGE,
            payload: UPLOADING_FILE,
          });
          dispatch({
            type: ON_DOCUMENT_DOWNLOAD,
            payload: true,
          });
          dispatch({
            type: ON_ONEDRIVE_FILE_TYPE_SELECTED,
            payload: "",
          });
          await authAxio
            .post("/api/DocumentManagement/check-in/new-revision", newRevisionObj, {
              headers: {
                "Ocp-Apim-Subscription-Key": subscriptionKey,
                "Customer-Key": new AuthTeams().getCustomerKey(),
                "User-Key": new AuthTeams().getUserKey(),
              },
            })
            .then((res) => {
              switch (res.status) {
                case 200:
                  dispatch({
                    type: ON_ATTACHED_DOC_INFO,
                    payload: res.data,
                  });
                  dispatch({
                    type: ON_PROCESS_SUCCESS,
                    payload: true,
                  });
                  dispatch({
                    type: ON_REVISIONSEARCH_ITEM_SELECT,
                    payload: [],
                  });

                  if (uploadViewCopyCount > 0) {
                    dispatch({
                      type: ON_DOCUMENT_DOWNLOAD,
                      payload: true,
                    });
                    dispatch({
                      type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
                      payload: DOCUMENT_LOAD_STATUS.onViewCopyUpload,
                    });
                  } else {
                    dispatch({
                      type: ON_DOCUMENT_DOWNLOAD,
                      payload: false,
                    });
                    dispatch({
                      type: ON_SUCCESS_DIALOG_MENU_OK_BUTTON_CLICK,
                      payload: true,
                    });
                    dispatch({
                      type: ON_CHECKIN_NEW_PAGE_NAME,
                      payload: CHECKIN_NEW_PAGE_NAME.file,
                    });
                    dispatch({
                      type: ON_ONEDRIVE_DATALOAD,
                      payload: DATA_LOAD_STATUS.onLoad,
                    });
                    if (oneDriveDeleteRequired) {
                      dispatch({
                        type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
                        payload: DOCUMENT_LOAD_STATUS.onDeleting,
                      });
                    } else {
                      dispatch({
                        type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
                        payload: DOCUMENT_LOAD_STATUS.onCompletion,
                      });
                    }
                  }
                  break;
                default:
                  let responseFailure = {
                    response: res,
                    statusCode: res.status,
                    error: null,
                    showMessageBox: false,
                  };
                  dispatch({
                    type: ON_SERVER_ERROR_MESSAGE_INVOKE,
                    payload: responseFailure,
                  });
                  dispatch({
                    type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
                    payload: DOCUMENT_LOAD_STATUS.onError,
                  });
                  dispatch({
                    type: ON_VIWE_DOCUMENT_WEB,
                    payload: { text: "", state: false },
                  });
                  dispatch({
                    type: ON_ATTACHED_DOC_INFO,
                    payload: INVALID_DOCUMENT,
                  });
                  dispatch({
                    type: ON_DOCUMENT_DOWNLOAD,
                    payload: false,
                  });
                  break;
              }
              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION,
                payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
              });
              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
                payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
              });
            })
            .catch(function (error) {
              console.log(error.toJSON(), "err");
              if (
                isTokenRefreshRequired(
                  error.response,
                  tokenRefreshPreAction,
                  REFRESH_TOKEN_ACTION.checkinNewRevision,
                )
              ) {
                dispatch({
                  type: ON_LOGIN_REFRESH_PREACTION,
                  payload: getUpdatedTokenRefreshPreAction(
                    tokenRefreshPreAction,
                    REFRESH_TOKEN_ACTION.checkinNewRevision,
                  ),
                });
                dispatch({
                  type: ON_IFS_USER_LOAD,
                  payload: USER_TOKEN_STATUS.refresh,
                });
              } else {
                let serverResponseError = {
                  response: error.response,
                  statusCode: error.response?.status || TIME_OUT_STATUS_CODE,
                  error: error,
                  showMessageBox: false,
                };
                dispatch({
                  type: ON_LOGIN_REFRESH_PREACTION,
                  payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
                });
                dispatch({
                  type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
                  payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
                });
                dispatch({
                  type: ON_SERVER_ERROR_MESSAGE_INVOKE,
                  payload: serverResponseError,
                });
                dispatch({
                  type: ON_VIWE_DOCUMENT_WEB,
                  payload: { text: "", state: false },
                });
                dispatch({
                  type: ON_ATTACHED_DOC_INFO,
                  payload: INVALID_DOCUMENT,
                });
                dispatch({
                  type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
                  payload: DOCUMENT_LOAD_STATUS.onError,
                });
                dispatch({
                  type: ON_DOCUMENT_DOWNLOAD,
                  payload: false,
                });
              }
            });
        }
      });
    } catch (ex) {
      let errorMessage = {
        message: ex.message,
        showMessageBox: false,
      };
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION,
        payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
      });
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
        payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
      });
      dispatch({
        type: ON_EXCEPTION_MESSAGE_INVOKE,
        payload: errorMessage,
      });
      dispatch({
        type: ON_VIWE_DOCUMENT_WEB,
        payload: { text: "", state: false },
      });
      dispatch({
        type: ON_ATTACHED_DOC_INFO,
        payload: INVALID_DOCUMENT,
      });
      dispatch({
        type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
        payload: DOCUMENT_LOAD_STATUS.onError,
      });
      dispatch({
        type: ON_DOCUMENT_DOWNLOAD,
        payload: false,
      });
    }
  };

export const onCheckinViewCopy =
  (
    docTitle,
    docClass,
    docNo,
    DocSheet,
    docRev,
    viewCopyFiles,
    viewRequired,
    docReleaseStatus,
    checkinType,
    deleteOriginal = false,
    tokenRefreshPreAction = {
      retry: 0,
      actionType: REFRESH_TOKEN_ACTION.none,
      refreshResponse: RESPONSE_TYPE.none,
    },
    actionType = REFRESH_TOKEN_ACTION.none,
  ) =>
  async (dispatch) => {
    const tokenResponse = await userAuth.getUserToken(true);
    const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
    if (!tokenOneDrive) {
      dispatch({
        type: ON_TOKEN_FAIL,
        payload: tokenResponse,
      });
      return;
    }
    if (isTokenRefreshFailed(tokenRefreshPreAction)) {
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION,
        payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
      });
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
        payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
      });

      let messageBox = {
        type: ERROR_TYPE,
        message: CREATE_VIECOPY_FAILED_TITLE,
        errorMessage: IFS_TOKEN_EXPIRED,
        domain: CHECKIN_VIEWCOPY
      };

      dispatch({
        type: ON_MESSAGE_BOX_INVOKE,
        payload: messageBox,
      });
      dispatch({
        type: ON_MESSAGE_BOX_OPEN,
        payload: true,
      });
      dispatch({
        type: ON_VIWE_DOCUMENT_WEB,
        payload: { text: "", state: false },
      });
      dispatch({
        type: ON_ATTACHED_DOC_INFO,
        payload: INVALID_DOCUMENT,
      });
      dispatch({
        type: ON_DOCUMENT_UPLOAD_FAILED,
        payload: true,
      });
      switch (checkinType) {
        case DOC_CHECK_IN_TYPE.checkinExisting:
          dispatch({
            type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
            payload: DOCUMENT_LOAD_STATUS.onCompletion,
          });
          break;
        case DOC_CHECK_IN_TYPE.checkinNewRevision:
          dispatch({
            type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
            payload: DOCUMENT_LOAD_STATUS.onCompletion,
          });
          break;
        case DOC_CHECK_IN_TYPE.checkinNew:
          dispatch({
            type: ON_CHECKIN_DOCUMENT_PROGRESS,
            payload: DOCUMENT_LOAD_STATUS.onCompletion,
          });
          break;
        default:
          dispatch({
            type: ON_CHECKIN_DOCUMENT_PROGRESS,
            payload: DOCUMENT_LOAD_STATUS.onError,
          });
      }
      // if (checkinType === DOC_CHECK_IN_TYPE.checkinExisting) {
      //   dispatch({
      //     type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
      //     payload: DOCUMENT_LOAD_STATUS.onCompletion,
      //   });
      // } else {
      //   dispatch({
      //     type: ON_CHECKIN_DOCUMENT_PROGRESS,
      //     payload: DATA_LOAD_STATUS.error,
      //   });
      // }

      dispatch({
        type: ON_DOCUMENT_DOWNLOAD,
        payload: false,
      });
      return;
    }

    try {
      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
        timeout: timeout(viewCopyFiles),
      });
      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;

      let uploadFilesList = viewCopyFiles;
      await Promise.all(uploadFilesList.map(async (uploadFile) => {
        const docInfo = {
          checkinViewCopy: true,
          docClass: docClass,
          docNo: docNo,
          docSheet: DocSheet,
          docRev: docRev,
          title: `${docTitle} View Copy`,
          fileData: uploadFile.base64str,
          fileName: uploadFile.name,
          rollbackRevisionOnFail: viewRequired,
          createViewCopy: false,
          webUser: new AuthTeams().getEmail(),
          status: docReleaseStatus === false ? "" : docReleaseStatus,
        };
        if (uploadFilesList.length > 0) {
          if (checkinType === DOC_CHECK_IN_TYPE.checkinExisting) {
            dispatch({
              type: ON_DOCUMENT_DOWNLOAD,
              payload: false,
            });
          } else {
            dispatch({
              type: ON_DOCUMENT_DOWNLOAD,
              payload: false,
            });
          }
          dispatch({
            type: ON_VIEWCOPY_UPLOAD_FAILED,
            payload: false,
          });
          dispatch({
            type: ON_DOCUMENT_UPLOAD_FAILED,
            payload: false,
          });
          await authAxio
            .post("/api/DocumentManagement/check-in", docInfo, {
              headers: {
                "Ocp-Apim-Subscription-Key": subscriptionKey,
                "Customer-Key": new AuthTeams().getCustomerKey(),
                "User-Key": new AuthTeams().getUserKey(),
              },
            })
            .then((res) => {
              switch (res.status) {
                case 200:
                  switch (checkinType) {
                    case DOC_CHECK_IN_TYPE.checkinExisting:
                      if (deleteOriginal) {
                        dispatch({
                          type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                          payload: DOCUMENT_LOAD_STATUS.onDeleting,
                        });
                      } else {
                        dispatch({
                          type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                          payload: DOCUMENT_LOAD_STATUS.onCompletion,
                        });
                      }
                      break;
                    case DOC_CHECK_IN_TYPE.checkinNewRevision:
                      if (deleteOriginal) {
                        dispatch({
                          type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
                          payload: DOCUMENT_LOAD_STATUS.onDeleting,
                        });
                      } else {
                        dispatch({
                          type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
                          payload: DOCUMENT_LOAD_STATUS.onCompletion,
                        });
                      }
                      break;
                    case DOC_CHECK_IN_TYPE.checkinNew:
                      if (deleteOriginal) {
                        dispatch({
                          type: ON_CHECKIN_DOCUMENT_PROGRESS,
                          payload: DOCUMENT_LOAD_STATUS.onDeleting,
                        });
                      } else {
                        dispatch({
                          type: ON_CHECKIN_DOCUMENT_PROGRESS,
                          payload: DOCUMENT_LOAD_STATUS.onCompletion,
                        });
                      }
                      break;
                    default:
                      dispatch({
                        type: ON_CHECKIN_DOCUMENT_PROGRESS,
                        payload: DOCUMENT_LOAD_STATUS.onStart,
                      });

                    // dispatch({
                    //   type: ON_CHECKIN_NEW_PAGE_NAME,
                    //   payload: CHECKIN_NEW_PAGE_NAME.file,
                    // });
                    // dispatch({
                    //   type: ON_SUCCESS_DIALOG_MENU_OK_BUTTON_CLICK,
                    //   payload: true,
                    // });
                  }
                  dispatch({
                    type: ON_VIEWCOPY_UPLOAD_FAILED,
                    payload: false,
                  });
                  dispatch({
                    type: ON_DOCUMENT_DOWNLOAD,
                    payload: false,
                  });
                  dispatch({
                    type: ON_VIEWCOPY_DOC_INFO,
                    payload: res.data,
                  });
                  dispatch({
                    type: ON_VIEWCOPYUPLOAD_CHANGE,
                    payload: [],
                  });
                  break;
                // case 201:
                //   dispatch({
                //     type: ON_VIEWCOPY_UPLOAD_FAILED,
                //     payload: false,
                //   });
                //   dispatch({
                //     type: ON_DOCUMENT_DOWNLOAD,
                //     payload: false,
                //   });
                //   dispatch({
                //     type: ON_VIEWCOPY_DOC_INFO,
                //     payload: res.data,
                //   });
                //   dispatch({
                //     type: ON_VIEWCOPY_UPLOAD_FAILED,
                //     payload: true,
                //   });
                //   dispatch({
                //     type: ON_CHECKIN_NEW_PAGE_NAME,
                //     payload: CHECKIN_NEW_PAGE_NAME.file,
                //   });
                //   dispatch({
                //     type: ON_SUCCESS_DIALOG_MENU_OK_BUTTON_CLICK,
                //     payload: true,
                //   });
                //   break;
                default:
                  let responseFailure = {
                    response: res,
                    statusCode: res.status,
                    error: null,
                    showMessageBox: false,
                    domain: CHECKIN_VIEWCOPY
                  };
                  dispatch({
                    type: ON_SERVER_ERROR_MESSAGE_INVOKE,
                    payload: responseFailure,
                  });
                  dispatch({
                    type: ON_VIWE_DOCUMENT_WEB,
                    payload: { text: "", state: false },
                  });
                  dispatch({
                    type: ON_ATTACHED_DOC_INFO,
                    payload: INVALID_DOCUMENT,
                  });
                  dispatch({
                    type: ON_DOCUMENT_UPLOAD_FAILED,
                    payload: true,
                  });
                  switch (checkinType) {
                    case DOC_CHECK_IN_TYPE.checkinExisting:
                      dispatch({
                        type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                        payload: DOCUMENT_LOAD_STATUS.onCompletion,
                      });
                      break;
                    case DOC_CHECK_IN_TYPE.checkinNewRevision:
                      dispatch({
                        type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
                        payload: DOCUMENT_LOAD_STATUS.onCompletion,
                      });
                      break;
                    case DOC_CHECK_IN_TYPE.checkinNew:
                      dispatch({
                        type: ON_CHECKIN_DOCUMENT_PROGRESS,
                        payload: DOCUMENT_LOAD_STATUS.onCompletion,
                      });
                      break;
                    default:
                      dispatch({
                        type: ON_CHECKIN_DOCUMENT_PROGRESS,
                        payload: DOCUMENT_LOAD_STATUS.onError,
                      });
                      break;
                  }
                  dispatch({
                    type: ON_DOCUMENT_DOWNLOAD,
                    payload: false,
                  });
                  break;
              }

              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION,
                payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
              });
              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
                payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
              });
            })
            .catch(function (error) {
              console.log(error.toJSON(), "err");
              if (
                isTokenRefreshRequired(
                  error.response,
                  tokenRefreshPreAction,
                  actionType,
                )
              ) {
                dispatch({
                  type: ON_LOGIN_REFRESH_PREACTION,
                  payload: getUpdatedTokenRefreshPreAction(
                    tokenRefreshPreAction,
                    actionType,
                  ),
                });
                dispatch({
                  type: ON_IFS_USER_LOAD,
                  payload: USER_TOKEN_STATUS.refresh,
                });
              } else {
                let serverResponseError = {
                  response: error.response,
                  statusCode: error.response?.status || TIME_OUT_STATUS_CODE,
                  error: error,
                  showMessageBox: false,
                  domain: CHECKIN_VIEWCOPY
                };
                dispatch({
                  type: ON_LOGIN_REFRESH_PREACTION,
                  payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
                });
                dispatch({
                  type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
                  payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
                });
                dispatch({
                  type: ON_SERVER_ERROR_MESSAGE_INVOKE,
                  payload: serverResponseError,
                });
                dispatch({
                  type: ON_VIWE_DOCUMENT_WEB,
                  payload: { text: "", state: false },
                });
                dispatch({
                  type: ON_ATTACHED_DOC_INFO,
                  payload: INVALID_DOCUMENT,
                });
                dispatch({
                  type: ON_DOCUMENT_UPLOAD_FAILED,
                  payload: true,
                });
                switch (checkinType) {
                  case DOC_CHECK_IN_TYPE.checkinExisting:
                    dispatch({
                      type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
                      payload: DOCUMENT_LOAD_STATUS.onCompletion,
                    });
                    break;
                  case DOC_CHECK_IN_TYPE.checkinNewRevision:
                    dispatch({
                      type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
                      payload: DOCUMENT_LOAD_STATUS.onCompletion,
                    });
                    break;
                  case DOC_CHECK_IN_TYPE.checkinNew:
                    dispatch({
                      type: ON_CHECKIN_DOCUMENT_PROGRESS,
                      payload: DOCUMENT_LOAD_STATUS.onCompletion,
                    });
                    break;
                  default:
                    dispatch({
                      type: ON_CHECKIN_DOCUMENT_PROGRESS,
                      payload: DOCUMENT_LOAD_STATUS.onError,
                    });
                    break;
                }
                dispatch({
                  type: ON_DOCUMENT_DOWNLOAD,
                  payload: false,
                });
              }
            });
        }
      }));
    } catch (ex) {
      console.log(ex.message, "err");
      let errorMessage = {
        message: ex.message,
        showMessageBox: false,
        domain: CHECKIN_VIEWCOPY
      };
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION,
        payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
      });
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
        payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
      });
      dispatch({
        type: ON_EXCEPTION_MESSAGE_INVOKE,
        payload: errorMessage,
      });
      dispatch({
        type: ON_VIWE_DOCUMENT_WEB,
        payload: { text: "", state: false },
      });
      dispatch({
        type: ON_ATTACHED_DOC_INFO,
        payload: INVALID_DOCUMENT,
      });
      dispatch({
        type: ON_DOCUMENT_UPLOAD_FAILED,
        payload: true,
      });
      switch (checkinType) {
        case DOC_CHECK_IN_TYPE.checkinExisting:
          dispatch({
            type: ON_CHECKIN_EXISTING_STATUS_CHANGE,
            payload: DOCUMENT_LOAD_STATUS.onCompletion,
          });
          break;
        case DOC_CHECK_IN_TYPE.checkinNewRevision:
          dispatch({
            type: ON_CHECKIN_NEW_REVISION_STATUS_CHANGE,
            payload: DOCUMENT_LOAD_STATUS.onCompletion,
          });
          break;
        case DOC_CHECK_IN_TYPE.checkinNew:
          dispatch({
            type: ON_CHECKIN_DOCUMENT_PROGRESS,
            payload: DOCUMENT_LOAD_STATUS.onCompletion,
          });
          break;
        default:
          dispatch({
            type: ON_CHECKIN_DOCUMENT_PROGRESS,
            payload: DOCUMENT_LOAD_STATUS.onError,
          });
          break;
      }
      dispatch({
        type: ON_DOCUMENT_DOWNLOAD,
        payload: false,
      });
    }
  };

export const onNewRevisionInfo =
  (
    rowSelectionDetails,
    uploadFiles,
    uploadViewCopyCount,
    requestDocRevInfo,
    documentCheckInType = DOC_CHECK_IN_TYPE.newRevision,
    tokenRefreshPreAction = DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
    actionType = REFRESH_TOKEN_ACTION.none,
  ) =>
  async (dispatch) => {
    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onNewRevisionInfo",
      statusCode: 0,
      selectedRows: null,
    };
    try {
      const tokenResponse = await userAuth.getUserToken(true);
      const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
      if (!tokenOneDrive) {
        dispatch({
          type: ON_TOKEN_FAIL,
          payload: tokenResponse,
        });
        return;
      }

      if (isTokenRefreshFailed(tokenRefreshPreAction)) {
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION,
          payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
        });
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
          payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
        });

        let messageBox = {
          type: ERROR_TYPE,
          message: NEW_REVISION_INFO_ERROR,
          errorMessage: IFS_TOKEN_EXPIRED,
        };

        dispatch({
          type: ON_MESSAGE_BOX_INVOKE,
          payload: messageBox,
        });
        dispatch({
          type: ON_MESSAGE_BOX_OPEN,
          payload: true,
        });
        dispatch({
          type: ON_VIWE_DOCUMENT_WEB,
          payload: { text: "", state: false },
        });
        dispatch({
          type: ON_RECENT_OBJECT_VALUES,
          payload: "invalid",
        });
        dispatch({
          type: ON_NEWREVISION_DISABLED,
          payload: false,
        });
        dispatch({
          type: ON_NEWREVISION_INFO_CHANGED,
          payload: DATA_LOAD_STATUS.error,
        });
        return;
      }

      const config = new CustomerConfig();
      appInsights.trackTrace({
        message: "Get New Revision Info",
        appInsightProps,
      });
      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
      });
      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;
      let selectedRow =
        rowSelectionDetails !== undefined &&
        rowSelectionDetails !== null &&
        rowSelectionDetails.length > 0
          ? rowSelectionDetails[0]
          : [];
      dispatch({
        type: ON_REVISIONSEARCH_ITEM_SELECT,
        payload: selectedRow,
      });
      dispatch({
        type: ON_NEWREVISION_DOC_INFO_CHANGED,
        payload: rowSelectionDetails,
      });
      dispatch({
        type: ON_NEWREVISION_CHANGED,
        payload: "",
      });
      dispatch({
        type: ON_NEWREVISION_DISABLED,
        payload: true,
      });
      dispatch({
        type: ON_NEWREVISION_OBJCON_CHANGED,
        payload: [],
      });
      dispatch({
        type: ON_DOCCLASS_CHANGED,
        payload: selectedRow.class,
      });
      if (selectedRow) {
        config.setOneDriveETag(getETag());
        dispatch({
          type: ON_NEWREVISION_INFO_CHANGED,
          payload: DATA_LOAD_STATUS.inProgress,
        });

        authAxio
          .get(
            `api/DocumentManagement/get-newrevisioninfo?webUser=${new AuthTeams().getEmail()}&docClass=${
              selectedRow.class
            }&docNo=${selectedRow.docNo}&docSheet=${
              selectedRow.sheetNo
            }&docRev=${
              selectedRow.docRev
            }&requestDocRevInfo=${requestDocRevInfo}`,
            {
              headers: {
                "Ocp-Apim-Subscription-Key": subscriptionKey,
                "Customer-Key": new AuthTeams().getCustomerKey(),
                "E-Tag": config.getOneDriveETag(),
                "User-Key": new AuthTeams().getUserKey(),
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              if (res.data?.eTag === config.getOneDriveETag()) {
                if (res.data?.newRevisionBasicInfo === null) {
                  dispatch({
                    type: ON_MESSAGE_BOX_INVOKE,
                    payload: {
                      type: ERROR_TYPE,
                      message: NO_REVISION_FOUND,
                      errorMessage: res.data != null ? res.data : "",
                      error: null,
                    },
                  });
                  dispatch({
                    type: ON_NEWREVISION_INFO_CHANGED,
                    payload: DATA_LOAD_STATUS.noDate,
                  });
                } else {
                  let dispatchInfo = true;
                  if (requestDocRevInfo) {
                    let documentRevision = res.data.documentRevision;
                    if (documentRevision) {
                      let messageBox;
                      let message = "";
                      let validRevision = true;
                      switch (documentCheckInType) {
                        case DOC_CHECK_IN_TYPE.checkinExisting:
                          if (
                            documentRevision.EdmStatus !== FILE_STATE.checkedOut
                          ) {
                            message = NOT_CHECK_OUT_WARNING;
                            validRevision = false;
                          }
                          break;
                        case DOC_CHECK_IN_TYPE.checkinNewRevision:
                          if (
                            documentRevision.EdmStatus === FILE_STATE.checkedOut
                          ) {
                            message = CHECK_OUT_WARNING;
                            validRevision = false;
                          }
                          break;
                        default:
                          message = "";
                          validRevision = true;
                          break;
                      }

                      if (!validRevision) {
                        messageBox = {
                          type: WARNING_TYPE,
                          message: message,
                          errorMessage: "",
                          error: null,
                        };
                        dispatch({
                          type: ON_MESSAGE_BOX_INVOKE,
                          payload: messageBox,
                        });
                        dispatch({
                          type: ON_MESSAGE_BOX_OPEN,
                          payload: true,
                        });
                        dispatchInfo = false;
                      } else {
                        let selectedRevisionItem = {
                          class: selectedRow.class,
                          docNo: selectedRow.docNo,
                          docRev: selectedRow.docRev,
                          sheetNo: selectedRow.sheetNo,
                          title: documentRevision.Title,
                          format: documentRevision.FormatSize,
                          documentNo: `${selectedRow.docNo} - ${selectedRow.docRev}`,
                        };
                        dispatch({
                          type: ON_REVISIONSEARCH_ITEM_SELECT,
                          payload: selectedRevisionItem,
                        });
                      }
                    }
                  }
                  if (dispatchInfo) {
                    let newRevisionBasicInfo = res.data.newRevisionBasicInfo;
                    let documentBasicInfo = res.data.documentBasicInfo;
                    dispatch({
                      type: ON_NEWREVISION_CHANGED,
                      payload: newRevisionBasicInfo.nextRevision,
                    });
                    dispatch({
                      type: ON_NEWREVISION_OBJCON_CHANGED,
                      payload: newRevisionBasicInfo.objectConnections,
                    });
                    const data = getDocClasses(documentBasicInfo?.classDetails);
                    dispatch({
                      type: ON_DOCDOCFORMATLIST_CHANGED,
                      payload: data,
                    });
                    dispatch({
                      type: ON_FILETYPES_CHANGED,
                      payload: documentBasicInfo?.fileTypeDetails,
                    });
                    dispatch({
                      type: ON_NEWREVISION_DISABLED,
                      payload: false,
                    });
                    let viewCopyRequired = MANDATORY_TYPE.no;
                    if (
                      data !== undefined &&
                      data !== null &&
                      data.length > 0
                    ) {
                      for (let i = 0; i < data.length; i++) {
                        if (data[i].code === selectedRow.class) {
                          if (data[i].viewRequired === MANDATORY_TYPE.yes) {
                            viewCopyRequired = MANDATORY_TYPE.yes;
                          }
                        }
                      }
                    }
                    dispatch({
                      type: ON_VIEWREQUIRED_CHANGED,
                      payload: viewCopyRequired,
                    });
                    if (viewCopyRequired === MANDATORY_TYPE.yes) {
                      if (
                        uploadFiles !== undefined &&
                        uploadFiles !== null &&
                        uploadFiles.length > 0
                      ) {
                        let createViewCopy = false;
                        if (
                          uploadViewCopyCount !== undefined &&
                          uploadViewCopyCount !== null &&
                          uploadViewCopyCount > 0
                        ) {
                          createViewCopy = false;
                        } else {
                          let title = uploadFiles[0].name;
                          let ext = uploadFiles[0].name;
                          title = title.replace(/\.[^/.]+$/, "");
                          ext = ext.split(".").pop().toUpperCase();
                          createViewCopy =
                            ext === "DOCX" || ext === "DOC" ? true : false;
                        }
                        dispatch({
                          type: ON_CREATE_VIEWCOPY_CHANGED,
                          payload: createViewCopy,
                        });
                      }
                    } else {
                      dispatch({
                        type: ON_CREATE_VIEWCOPY_CHANGED,
                        payload: false,
                      });
                    }
                  }
                }
              }
              dispatch({
                type: ON_NEWREVISION_INFO_CHANGED,
                payload: DATA_LOAD_STATUS.completed,
              });
            } else {
              let messageBox = {
                type: ERROR_TYPE,
                message: IFS_SERVER_ERROR,
                errorMessage: "",
                error: null,
              };
              appInsightProps.statusCode = res.status;
              if (res.status === 204) {
                messageBox.message = `${NO_CONTENT_FOUND}`;
                appInsights.trackException({
                  error: `${NO_CONTENT_FOUND}`,
                  appInsightProps,
                });
              } else {
                appInsights.trackException({
                  error: `${IFS_SERVER_ERROR}`,
                  appInsightProps,
                });
              }

              dispatch({
                type: ON_MESSAGE_BOX_INVOKE,
                payload: messageBox,
              });
              dispatch({
                type: ON_MESSAGE_BOX_OPEN,
                payload: true,
              });
              dispatch({
                type: ON_VIWE_DOCUMENT_WEB,
                payload: { text: "", state: false },
              });
              dispatch({
                type: ON_RECENT_OBJECT_VALUES,
                payload: "invalid",
              });
              dispatch({
                type: ON_NEWREVISION_DISABLED,
                payload: false,
              });
              dispatch({
                type: ON_NEWREVISION_INFO_CHANGED,
                payload: DATA_LOAD_STATUS.completed,
              });
            }

            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
            });
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
              payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
            });
          })
          .catch(function (error) {
            console.log(error.toJSON(), "err");
            if (
              isTokenRefreshRequired(
                error.response,
                tokenRefreshPreAction,
                actionType,
              )
            ) {
              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION,
                payload: getUpdatedTokenRefreshPreAction(
                  tokenRefreshPreAction,
                  actionType,
                ),
              });
              dispatch({
                type: ON_IFS_USER_LOAD,
                payload: USER_TOKEN_STATUS.refresh,
              });
            } else {
              appInsightProps.statusCode =
                error.response === undefined ? 0 : error.response.status;
              appInsights.trackException({
                error: error.toJSON(),
                appInsightProps,
              });
              let messageBox = {
                type: ERROR_TYPE,
                message: FAILED_REVISION_INFO,
                errorMessage: "",
                error: error.toJSON(),
              };
              if (error.response.data) {
                messageBox.errorMessage =
                  error.response.status === 400
                    ? `${error.response.data}`
                    : `${error.toJSON().message}`;
              } else if (error.request.response) {
                messageBox.errorMessage = `${error.request.response}`;
              } else {
                messageBox.errorMessage =
                  error !== null
                    ? `${ERROR_DETAILS} ${error.toJSON().message}`
                    : `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
              }
              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION,
                payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
              });
              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
                payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
              });
              dispatch({
                type: ON_MESSAGE_BOX_INVOKE,
                payload: messageBox,
              });
              dispatch({
                type: ON_MESSAGE_BOX_OPEN,
                payload: true,
              });
              dispatch({
                type: ON_VIWE_DOCUMENT_WEB,
                payload: { text: "", state: false },
              });
              dispatch({
                type: ON_RECENT_OBJECT_VALUES,
                payload: "invalid",
              });
              dispatch({
                type: ON_NEWREVISION_DISABLED,
                payload: false,
              });
              dispatch({
                type: ON_NEWREVISION_INFO_CHANGED,
                payload: DATA_LOAD_STATUS.error,
              });
              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION,
                payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
              });
              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
                payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
              });
            }
          });
      }
    } catch (ex) {
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION,
        payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
      });
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
        payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
      });
      dispatch({
        type: ON_MESSAGE_BOX_INVOKE,
        payload: {
          type: ERROR_TYPE,
          message: FAILED_REVISION_INFO,
          errorMessage: ex.message,
          error: null,
        },
      });
      dispatch({
        type: ON_MESSAGE_BOX_OPEN,
        payload: true,
      });
      dispatch({
        type: ON_RECENT_OBJECT_VALUES,
        payload: "invalid",
      });
      dispatch({
        type: ON_NEWREVISION_DISABLED,
        payload: false,
      });
      dispatch({
        type: ON_NEWREVISION_INFO_CHANGED,
        payload: DATA_LOAD_STATUS.error,
      });
      console.log(ex.message, "err");
      appInsightProps.statusCode = 0;
      appInsights.trackException({ error: ex.message, appInsightProps });
      return null;
    }
  };

export const getRecentObjects =
  (
    tokenRefreshPreAction = {
      retry: 0,
      actionType: REFRESH_TOKEN_ACTION.none,
      refreshResponse: RESPONSE_TYPE.none,
    },
  ) =>
  async (dispatch) => {
    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "getRecentObjects",
      statusCode: 0,
      selectedRows: null,
    };
    try {
      const tokenResponse = await userAuth.getUserToken(true);
      const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
      if (!tokenOneDrive) {
        dispatch({
          type: ON_TOKEN_FAIL,
          payload: tokenResponse,
        });
        dispatch({
          type: ON_RECENT_OBJECTS_DATA_LOAD_STATUS,
          payload: DOCUMENT_LOAD_STATUS.onError,
        });
        dispatch({
          type: ON_RECENT_OBJECTS_DATA_ERROR_MESSAGE,
          payload: RECENT_OBJECT_DATA_ERROR,
        });
        return;
      }

      if (isTokenRefreshFailed(tokenRefreshPreAction)) {
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION,
          payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
        });
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
          payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
        });

        let messageBox = {
          type: ERROR_TYPE,
          message: RECENT_OBJECT_DATA_ERROR,
          errorMessage: IFS_TOKEN_EXPIRED,
        };

        dispatch({
          type: ON_MESSAGE_BOX_INVOKE,
          payload: messageBox,
        });
        dispatch({
          type: ON_MESSAGE_BOX_OPEN,
          payload: true,
        });
        dispatch({
          type: ON_RECENT_OBJECTS_DATA_LOAD_STATUS,
          payload: DOCUMENT_LOAD_STATUS.onError,
        });
        dispatch({
          type: ON_RECENT_OBJECTS_DATA_ERROR_MESSAGE,
          payload: messageBox.message,
        });
        return;
      }

      appInsights.trackTrace({
        message: "Get Recent Objects",
        appInsightProps,
      });
      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
      });
      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;

      dispatch({
        type: ON_RECENT_OBJECTS_DATA_LOAD_STATUS,
        payload: DOCUMENT_LOAD_STATUS.onLoading,
      });

      authAxio
        .get(
          `api/DocumentManagement/get-recentobjects?webUser=${encodeURIComponent(
            new AuthTeams().getEmail(),
          )}${
            (() => {
              try {
                const raw = localStorage.getItem("ifsUserDetails");
                const parsed = raw ? JSON.parse(raw) : null;
                const ifsUser = parsed?.UserEmail ?? parsed?.WebUser ?? "";
                return ifsUser ? `&ifsUser=${encodeURIComponent(ifsUser)}` : "";
              } catch {
                return "";
              }
            })()
          }`,
          {
          headers: {
            "Ocp-Apim-Subscription-Key": subscriptionKey,
            "Customer-Key": new AuthTeams().getCustomerKey(),
            "User-Key": new AuthTeams().getUserKey(),
          },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            dispatch({
              type: ON_RECENT_OBJECTS_CHANGED,
              payload: res.data,
            });
            dispatch({
              type: ON_RECENT_OBJECTS_DATA_LOAD_STATUS,
              payload: DOCUMENT_LOAD_STATUS.onCompletion,
            });
          } else {
            appInsightProps.statusCode = res.status;
            dispatch({
              type: ON_RECENT_OBJECTS_DATA_ERROR_MESSAGE,
              payload: NO_CLASSFORMAT_FOUND,
            });
            if (res.status === 204) {
              appInsights.trackException({
                error: `${NO_CLASSFORMAT_FOUND}`,
                appInsightProps,
              });
              dispatch({
                type: ON_RECENT_OBJECTS_DATA_LOAD_STATUS,
                payload: DOCUMENT_LOAD_STATUS.noData,
              });
            } else {
              appInsights.trackException({
                error: `${IFS_SERVER_ERROR}`,
                errorMessage: res.data,
                appInsightProps,
              });
              dispatch({
                type: ON_RECENT_OBJECTS_DATA_ERROR_MESSAGE,
                payload: IFS_SERVER_ERROR,
              });
              dispatch({
                type: ON_RECENT_OBJECTS_DATA_LOAD_STATUS,
                payload: DOCUMENT_LOAD_STATUS.onError,
              });
            }
          }
          dispatch({
            type: ON_LOGIN_REFRESH_PREACTION,
            payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
          });
          dispatch({
            type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
            payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
          });
        })
        .catch(async function (error) {
          console.log(error.toJSON(), "err");
          if (
            isTokenRefreshRequired(
              error.response,
              tokenRefreshPreAction,
              REFRESH_TOKEN_ACTION.recentlyUsedObjectsLoad,
            )
          ) {
            const updatedPreAction = getUpdatedTokenRefreshPreAction(
              tokenRefreshPreAction,
              REFRESH_TOKEN_ACTION.recentlyUsedObjectsLoad,
            );
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: updatedPreAction,
            });
            dispatch({
              type: ON_IFS_USER_LOAD,
              payload: USER_TOKEN_STATUS.refresh,
            });
            try {
              const { fetchIfsToken } = await import("./login/loginThunks");
              await dispatch(
                fetchIfsToken({
                  refreshToken: true,
                  silent: true,
                  preAction: updatedPreAction,
                }),
              ).unwrap();
            } catch (refreshErr) {
              console.log(
                refreshErr?.message ?? refreshErr,
                "IFS token refresh failed (recent objects)",
              );
              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION,
                payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
              });
              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
                payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
              });
              dispatch({
                type: ON_RECENT_OBJECTS_DATA_LOAD_STATUS,
                payload: DOCUMENT_LOAD_STATUS.onError,
              });
              dispatch({
                type: ON_RECENT_OBJECTS_DATA_ERROR_MESSAGE,
                payload: RECENT_OBJECT_DATA_ERROR,
              });
            }
            return;
          } else {
            appInsightProps.statusCode =
              error.response === undefined ? 0 : error.response.status;
            appInsights.trackException({
              error: error.toJSON(),
              appInsightProps,
            });
            let messageBox = {
              type: ERROR_TYPE,
              message: RECENT_OBJECT_DATA_ERROR,
              errorMessage: "",
              error: error.toJSON(),
            };

            if (error.response) {
              messageBox.errorMessage = `${error.toJSON().message}`;
            } else if (error.request) {
              messageBox.errorMessage = `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
            } else {
              messageBox.errorMessage =
                error !== null
                  ? `${ERROR_DETAILS} ${error.toJSON().message}`
                  : `${ERROR_DETAILS} ${UNKOWN_ERROR}`;
            }
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
            });
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
              payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
            });
            dispatch({
              type: ON_RECENT_OBJECTS_DATA_LOAD_STATUS,
              payload: DOCUMENT_LOAD_STATUS.onError,
            });
            dispatch({
              type: ON_RECENT_OBJECTS_DATA_ERROR_MESSAGE,
              payload: messageBox.message,
            });
          }
        });
    } catch (ex) {
      dispatch({
        type: ON_RECENT_OBJECTS_DATA_LOAD_STATUS,
        payload: DOCUMENT_LOAD_STATUS.onError,
      });
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION,
        payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
      });
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
        payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
      });
      console.log(ex.message, "err");
      appInsightProps.statusCode = 0;
      appInsights.trackException({ error: ex.message, appInsightProps });
      dispatch({
        type: ON_RECENT_OBJECTS_DATA_ERROR_MESSAGE,
        payload: `${ERROR_DETAILS} ${ex.message}`,
      });
      dispatch({
        type: ON_MESSAGE_BOX_INVOKE,
        payload: {
          type: ERROR_TYPE,
          message: ON_RECENT_OBJECTS_DATA_ERROR_MESSAGE,
          errorMessage: ex.message,
          error: null,
        },
      });
      dispatch({
        type: ON_MESSAGE_BOX_OPEN,
        payload: true,
      });
      return null;
    }
  };

export const onGetObjectConnectionColumns =
  (
    LuName,
    KeyValue,
    SelectedItems,
    tokenRefreshPreAction = {
      retry: 0,
      actionType: REFRESH_TOKEN_ACTION.advanceSearchObjectColumnssLoad,
      refreshResponse: RESPONSE_TYPE.none,
    },
  ) =>
  async (dispatch) => {
    const tokenResponse = await userAuth.getUserToken(true);
    const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
    if (!tokenOneDrive) {
      dispatch({
        type: ON_TOKEN_FAIL,
        payload: tokenResponse,
      });
      return;
    }

    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onGetObjectConnectionColumns",
      statusCode: 0,
      selectedRows: null,
    };
    try {
      if (isTokenRefreshFailed(tokenRefreshPreAction)) {
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION,
          payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
        });
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
          payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
        });
        dispatch({
          type: ON_MESSAGE_BOX_INVOKE,
          payload: {
            type: ERROR_TYPE,
            message: IFS_TOKEN_EXPIRED,
            errorMessage: "",
            error: null,
          },
        });
        dispatch({
          type: ON_MESSAGE_BOX_OPEN,
          payload: true,
        });
        return null;
      }
      appInsights.trackTrace({
        message: "Get ObjectConnection Columns",
        appInsightProps,
      });
      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
      });
      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;
      authAxio
        .get(
          new CustomerConfig().getServiceApi() +
            `api/DocumentManagement/get-objectconnectioncolumnsinfo?luName=${
              LuName.luName
            }&webUser=${new AuthTeams().getEmail()}`,
          {
            headers: {
              "Ocp-Apim-Subscription-Key": subscriptionKey,
              "Customer-Key": new AuthTeams().getCustomerKey(),
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            let keyRef = res.data.KeyRef;
            let keyDesc = "";
            let lovColPrompts = res.data.LovColPrompts;
            if (lovColPrompts != null && lovColPrompts !== "") {
              let keyNames = lovColPrompts.split("^");
              if (keyNames != null && keyNames.length > 0) {
                keyDesc = `${keyNames[0]}: ${KeyValue}`;
              }
            }

            if (keyRef !== "" && keyRef !== undefined) {
              keyRef = keyRef.replace("^", `${KeyValue}^`);
            }
            dispatch({
              type: ON_SEARCH_KEY_REF,
              payload: keyRef,
            });
            let searchObjects =
              SelectedItems === undefined
                ? []
                : SelectedItems !== null
                  ? SelectedItems
                  : [];
            searchObjects.push({
              keyRef: keyRef,
              nameDesc: LuName.nameDesc,
              keyDesc: keyDesc,
              luName: LuName.luName,
            });
            dispatch({
              type: ON_ROW_SELECTION_CHANGE_RECENT_OBJECTS,
              payload: searchObjects,
            });

            return res.data;
          } else {
            let messageBox = {
              type: ERROR_TYPE,
              message: IFS_SERVER_ERROR,
              errorMessage: "",
              error: null,
            };
            appInsightProps.statusCode = res.status;
            if (res.status === 204) {
              messageBox.message = `${NO_CONTENT_FOUND}`;
              appInsights.trackException({
                error: `${NO_CONTENT_FOUND}`,
                appInsightProps,
              });
            } else {
              appInsights.trackException({
                error: `${IFS_SERVER_ERROR}`,
                appInsightProps,
              });
            }

            dispatch({
              type: ON_MESSAGE_BOX_INVOKE,
              payload: messageBox,
            });
            dispatch({
              type: ON_MESSAGE_BOX_OPEN,
              payload: true,
            });
          }
        })
        .catch(function (error) {
          console.log(error.toJSON(), "err");
          if (
            isTokenRefreshRequired(
              error.response,
              {
                ...tokenRefreshPreAction,
                actionType: REFRESH_TOKEN_ACTION.advanceSearchObjectColumnssLoad,
              },
              REFRESH_TOKEN_ACTION.advanceSearchObjectColumnssLoad,
            )
          ) {
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: getUpdatedTokenRefreshPreAction(
                {
                  ...tokenRefreshPreAction,
                  actionType: REFRESH_TOKEN_ACTION.advanceSearchObjectColumnssLoad,
                },
                REFRESH_TOKEN_ACTION.advanceSearchObjectColumnssLoad,
              ),
            });
            dispatch({
              type: ON_IFS_USER_LOAD,
              payload: USER_TOKEN_STATUS.refresh,
            });
            return;
          }
          if (userAuth.isIfsUserLoginRequired(error.response)) {
            // Trigger IFS User Login (fallback).
            dispatch({
              type: ON_IFS_USER_LOAD,
              payload: USER_TOKEN_STATUS.refresh,
            });
          }
          appInsightProps.statusCode =
            error.response === undefined ? 0 : error.response.status;
          appInsights.trackException({
            error: error.toJSON(),
            appInsightProps,
          });
          dispatch({
            type: ON_DOCUMENT_DOWNLOAD,
            payload: false,
          });
          let messageBox = {
            type: ERROR_TYPE,
            message: FAILED_OBJECT_COLUMNS,
            errorMessage: "",
            error: error.toJSON(),
          };
          if (error.response.data) {
            messageBox.errorMessage =
              error.response.status === 400
                ? `${error.response.data}`
                : `${error.toJSON().message}`;
          } else if (error.request.response) {
            messageBox.errorMessage = `${error.request.response}`;
          } else {
            messageBox.errorMessage =
              error !== null
                ? `${ERROR_DETAILS} ${error.toJSON().message}`
                : `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
          }
          dispatch({
            type: ON_MESSAGE_BOX_INVOKE,
            payload: messageBox,
          });
          dispatch({
            type: ON_MESSAGE_BOX_OPEN,
            payload: true,
          });
        });
    } catch (ex) {
      dispatch({
        type: ON_MESSAGE_BOX_INVOKE,
        payload: {
          type: ERROR_TYPE,
          message: FAILED_OBJECT_COLUMNS,
          errorMessage: ex.message,
          error: null,
        },
      });
      dispatch({
        type: ON_MESSAGE_BOX_OPEN,
        payload: true,
      });
      console.log(ex.message, "err");
      appInsightProps.statusCode = 0;
      appInsights.trackException({ error: ex.message, appInsightProps });
      return null;
    }
  };

export const onObjectConnectionsLoad =
  (
    teamsContext,
    tokenRefreshPreAction = {
      retry: 0,
      actionType: REFRESH_TOKEN_ACTION.none,
      refreshResponse: RESPONSE_TYPE.none,
    },
  ) =>
  async (dispatch) => {
    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onObjectConnectionsLoad",
      statusCode: 0,
      selectedRows: null,
    };
    try {
      const tokenResponse = await userAuth.getUserToken(true);
      const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
      if (!tokenOneDrive) {
        dispatch({
          type: ON_TOKEN_FAIL,
          payload: tokenResponse,
        });
        return;
      }

      if (isTokenRefreshFailed(tokenRefreshPreAction)) {
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION,
          payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
        });
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
          payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
        });

        let messageBox = {
          type: ERROR_TYPE,
          message: DOCUMENT_LOGICAL_UNITS_ERROR,
          errorMessage: IFS_TOKEN_EXPIRED,
        };

        dispatch({
          type: ON_MESSAGE_BOX_INVOKE,
          payload: messageBox,
        });
        dispatch({
          type: ON_MESSAGE_BOX_OPEN,
          payload: true,
        });
        dispatch({
          type: ON_OBJECTCONNECTION_DATALOAD,
          payload: DATA_LOAD_STATUS.error,
        });
        return;
      }

      appInsights.trackTrace({
        message: "Get Class with Format",
        appInsightProps,
      });
      const authAxio = axios.create({
        baseURL: new CustomerConfig().getServiceApi(),
      });

      dispatch({
        type: ON_RECENT_OBJECT_SELECTED,
        payload: [],
      });

      dispatch({
        type: ON_OBJECTCONNECTION_DATALOAD,
        payload: DATA_LOAD_STATUS.onLoad,
      });

      let groupId =
        teamsContext.channel !== undefined
          ? teamsContext.channel.membershipType === "Private"
            ? teamsContext.channel.ownerGroupId
            : teamsContext.team.groupId
          : "";
      let channelId =
        teamsContext.channel !== undefined ? teamsContext.channel.id : "";
      authAxio.defaults.headers.common.authorization = `Bearer ${tokenOneDrive}`;
      authAxio
        .get(
          "api/DocumentManagement/get-logicalunits?webUser=" +
            new AuthTeams().getEmail() +
            "&tenantId=" +
            teamsContext.user.tenant.id +
            "&groupId=" +
            groupId +
            "&channelId=" +
            channelId,
          {
            headers: {
              "Ocp-Apim-Subscription-Key": subscriptionKey,
              "Customer-Key": new AuthTeams().getCustomerKey(),
              "User-Key": new AuthTeams().getUserKey(),
            },
          },
        )
        .then((res) => {
          switch (res.status) {
            case 200:
              dispatch({
                type: LOGICALUNIT_VALUES,
                payload: res.data.logicalUnits,
              });
              let predefinedObjects = res.data.selectedObjectConnections;
              let selectedObj = [];
              if (
                predefinedObjects !== undefined &&
                predefinedObjects !== null &&
                predefinedObjects.length > 0
              ) {
                predefinedObjects.map((obj) => {
                  selectedObj.push(obj);
                });
              }

              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION,
                payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
              });
              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
                payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
              });
              dispatch({
                type: ON_SELECTED_OBJECTS_CHANGED,
                payload: selectedObj !== null ? selectedObj.sort() : [],
              });

              dispatch({
                type: ON_RECENT_OBJECT_SELECTED,
                payload:
                  predefinedObjects !== undefined && predefinedObjects !== null
                    ? predefinedObjects
                    : [],
              });

              dispatch({
                type: ON_OBJECTCONNECTION_DATALOAD,
                payload: DATA_LOAD_STATUS.completed,
              });
              break;
            case 201:
              dispatch({
                type: LOGICALUNIT_VALUES,
                payload: res.data.logicalUnits,
              });

              dispatch({
                type: ON_OBJECTCONNECTION_DATALOAD,
                payload: DATA_LOAD_STATUS.completed,
              });
              if (teamsContext.channel !== undefined) {
                let defaultConnectionMessageBox = {
                  type: WARNING_TYPE,
                  message: `${NO_DEFAULT_OBJECTS_FOUND}`,
                  errorMessage: "",
                  error: null,
                };
                dispatch({
                  type: ON_MESSAGE_BOX_INVOKE,
                  payload: defaultConnectionMessageBox,
                });
                dispatch({
                  type: ON_MESSAGE_BOX_OPEN,
                  payload: true,
                });
              }
              break;
            default:
              let messageBox = {
                type: ERROR_TYPE,
                message: IFS_SERVER_ERROR,
                errorMessage: "",
                error: null,
              };
              appInsightProps.statusCode = res.status;
              if (res.status === 204) {
                messageBox.message = `${NO_LOGICALUNIT_FOUND}`;
                appInsights.trackException({
                  error: `${NO_LOGICALUNIT_FOUND}`,
                  appInsightProps,
                });
                dispatch({
                  type: ON_OBJECTCONNECTION_DATALOAD,
                  payload: DATA_LOAD_STATUS.noDate,
                });
              } else {
                appInsights.trackException({
                  error: `${IFS_SERVER_ERROR}`,
                  appInsightProps,
                });
                messageBox.error = `${IFS_SERVER_ERROR}`;
                messageBox.errorMessage =
                  res.data !== "" && res.data !== null
                    ? res.data
                    : `${FAILED_LOGICALUNIT_FOUND}`;

                dispatch({
                  type: ON_OBJECTCONNECTION_DATALOAD,
                  payload: DATA_LOAD_STATUS.error,
                });
              }

              dispatch({
                type: ON_MESSAGE_BOX_INVOKE,
                payload: messageBox,
              });
              dispatch({
                type: ON_MESSAGE_BOX_OPEN,
                payload: true,
              });
              break;
          }
        })
        .catch(async function (error) {
          console.log(error.toJSON(), "err");
          if (
            isTokenRefreshRequired(
              error.response,
              tokenRefreshPreAction,
              REFRESH_TOKEN_ACTION.logicalUnitsLoad,
            )
          ) {
            const updatedPreAction = getUpdatedTokenRefreshPreAction(
              tokenRefreshPreAction,
              REFRESH_TOKEN_ACTION.logicalUnitsLoad,
            );
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: updatedPreAction,
            });
            dispatch({
              type: ON_IFS_USER_LOAD,
              payload: USER_TOKEN_STATUS.refresh,
            });
            try {
              const { fetchIfsToken } = await import("./login/loginThunks");
              await dispatch(
                fetchIfsToken({
                  refreshToken: true,
                  silent: true,
                  preAction: updatedPreAction,
                }),
              ).unwrap();
            } catch (refreshErr) {
              console.log(
                refreshErr?.message ?? refreshErr,
                "IFS token refresh failed (logical units)",
              );
              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION,
                payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
              });
              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
                payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
              });
              dispatch({
                type: ON_OBJECTCONNECTION_DATALOAD,
                payload: DATA_LOAD_STATUS.error,
              });
            }
            return;
          } else {
            appInsightProps.statusCode =
              error.response === undefined ? 0 : error.response.status;
            appInsights.trackException({
              error: error.toJSON(),
              appInsightProps,
            });
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
            });
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
              payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
            });
            dispatch({
              type: ON_DOCUMENT_DOWNLOAD,
              payload: false,
            });
            let messageBox = {
              type: ERROR_TYPE,
              message: DOCUMENT_LOGICAL_UNITS_ERROR,
              errorMessage: "",
              error: error.toJSON(),
            };
            if (error.response.data) {
              messageBox.errorMessage =
                error.response.status === 400
                  ? `${error.response.data}`
                  : `${error.toJSON().message}`;
            } else if (error.request.response) {
              messageBox.errorMessage = `${error.request.response}`;
            } else {
              messageBox.errorMessage =
                error !== null
                  ? `${ERROR_DETAILS} ${error.toJSON().message}`
                  : `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
            }
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
            });
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
              payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
            });
            dispatch({
              type: ON_MESSAGE_BOX_INVOKE,
              payload: messageBox,
            });
            dispatch({
              type: ON_MESSAGE_BOX_OPEN,
              payload: true,
            });
            dispatch({
              type: ON_OBJECTCONNECTION_DATALOAD,
              payload: DATA_LOAD_STATUS.error,
            });
          }
        });
    } catch (ex) {
      dispatch({
        type: ON_MESSAGE_BOX_INVOKE,
        payload: {
          type: ERROR_TYPE,
          message: FAILED_OBJECT_COLUMNS,
          errorMessage: ex.message,
          error: null,
        },
      });
      dispatch({
        type: ON_MESSAGE_BOX_OPEN,
        payload: true,
      });
      dispatch({
        type: ON_OBJECTCONNECTION_DATALOAD,
        payload: DATA_LOAD_STATUS.error,
      });
      console.log(ex.message, "err");
      appInsightProps.statusCode = 0;
      appInsights.trackException({ error: ex.message, appInsightProps });
      return null;
    }
  };

export const onBasicDataLoad =
  (
    tokenRefreshPreAction = {
      retry: 0,
      actionType: REFRESH_TOKEN_ACTION.none,
      refreshResponse: RESPONSE_TYPE.none,
    },
  ) =>
  async (dispatch) => {
    let appInsightProps = {
      userId: new AuthTeams().getEmail(),
      functionName: "onBasicDataLoad",
      statusCode: 0,
      selectedRows: null,
    };

    try {
      const tokenResponse = await userAuth.getUserToken(true);
      const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
      if (!tokenOneDrive) {
        dispatch({
          type: ON_TOKEN_FAIL,
          payload: tokenResponse,
        });
        return;
      }

      if (isTokenRefreshFailed(tokenRefreshPreAction)) {
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION,
          payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
        });
        dispatch({
          type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
          payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
        });

        let messageBox = {
          type: ERROR_TYPE,
          message: DOCUMENT_BASIC_DATA_ERROR,
          errorMessage: IFS_TOKEN_EXPIRED,
        };

        dispatch({
          type: ON_MESSAGE_BOX_INVOKE,
          payload: messageBox,
        });
        dispatch({
          type: ON_MESSAGE_BOX_OPEN,
          payload: true,
        });
        dispatch({
          type: ON_BASIC_DATA_INFO_CHANGED,
          payload: DATA_LOAD_STATUS.error,
        });
        return;
      }

      appInsights.trackTrace({
        message: "Get Class with Format",
        appInsightProps,
      });
      const apiClient = getApiClient(tokenOneDrive);
      dispatch({
        type: ON_DOCDOCFORMATLIST_CHANGED,
        payload: [],
      });
      apiClient
        .get(
          `/api/DocumentManagement/get-docbasicinfo?webUser=${encodeURIComponent(new AuthTeams().getEmail())}`,
        )
        .then((res) => {
          switch (res.status) {
            case 200:
              const data = getDocClasses(res.data.classDetails);
              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION,
                payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
              });
              dispatch({
                type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
                payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
              });
              dispatch({
                type: ON_DOCDOCFORMATLIST_CHANGED,
                payload: data,
              });
              dispatch({
                type: ON_FILETYPES_CHANGED,
                payload: res.data.fileTypeDetails,
              });
              dispatch({
                type: ON_BASIC_DATA_INFO_CHANGED,
                payload: DATA_LOAD_STATUS.completed,
              });
              break;
            case 204:
              dispatch({
                type: ON_BASIC_DATA_INFO_CHANGED,
                payload: DATA_LOAD_STATUS.noDate,
              });
              break;
            default:
              let messageBox = {
                type: ERROR_TYPE,
                message: IFS_SERVER_ERROR,
                errorMessage: "",
                error: null,
              };
              appInsightProps.statusCode = res.status;
              appInsights.trackException({
                error: `${IFS_SERVER_ERROR}`,
                appInsightProps,
              });
              messageBox.error = `${IFS_SERVER_ERROR}`;
              messageBox.errorMessage =
                res.data !== "" && res.data !== null
                  ? res.data
                  : `${DOCUMENT_BASIC_DATA_ERROR}`;

              dispatch({
                type: ON_BASIC_DATA_INFO_CHANGED,
                payload: DATA_LOAD_STATUS.ifsError,
              });
              dispatch({
                type: ON_MESSAGE_BOX_INVOKE,
                payload: messageBox,
              });
              dispatch({
                type: ON_MESSAGE_BOX_OPEN,
                payload: true,
              });
              break;
          }
        })
        .catch(function (error) {
          console.log(error.toJSON(), "err");
          if (
            isTokenRefreshRequired(
              error.response,
              tokenRefreshPreAction,
              REFRESH_TOKEN_ACTION.documentBasicInfoLoad,
            )
          ) {
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: getUpdatedTokenRefreshPreAction(
                tokenRefreshPreAction,
                REFRESH_TOKEN_ACTION.documentBasicInfoLoad,
              ),
            });
            dispatch({
              type: ON_IFS_USER_LOAD,
              payload: USER_TOKEN_STATUS.refresh,
            });
          } else {
            appInsightProps.statusCode =
              error.response === undefined ? 0 : error.response.status;
            appInsights.trackException({
              error: error.toJSON(),
              appInsightProps,
            });
            let messageBox = {
              type: ERROR_TYPE,
              message: DOCUMENT_BASIC_DATA_ERROR,
              errorMessage: "",
              error: error.toJSON(),
            };
            if (error.response.data) {
              messageBox.errorMessage =
                error.response.status === 400
                  ? `${error.response.data}`
                  : `${error.toJSON().message}`;
            } else if (error.request.response) {
              messageBox.errorMessage = `${error.request.response}`;
            } else {
              messageBox.errorMessage =
                error !== null
                  ? `${ERROR_DETAILS} ${error.toJSON().message}`
                  : `${ERROR_DETAILS} ${SERVER_RESPONSE_ERROR}`;
            }

            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION,
              payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
            });
            dispatch({
              type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
              payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
            });
            dispatch({
              type: ON_MESSAGE_BOX_INVOKE,
              payload: messageBox,
            });
            dispatch({
              type: ON_MESSAGE_BOX_OPEN,
              payload: true,
            });
            dispatch({
              type: ON_BASIC_DATA_INFO_CHANGED,
              payload: DATA_LOAD_STATUS.error,
            });
          }
        });
    } catch (ex) {
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION,
        payload: DEFAULT_REFRESH_TOKEN_PRE_ACTION,
      });
      dispatch({
        type: ON_LOGIN_REFRESH_PREACTION_INVOKE,
        payload: DEFAULT_REFRESH_TOKEN_ACTION_INVOKED,
      });
      dispatch({
        type: ON_MESSAGE_BOX_INVOKE,
        payload: {
          type: ERROR_TYPE,
          message: FAILED_OBJECT_COLUMNS,
          errorMessage: ex.message,
          error: null,
        },
      });
      dispatch({
        type: ON_MESSAGE_BOX_OPEN,
        payload: true,
      });
      dispatch({
        type: ON_BASIC_DATA_INFO_CHANGED,
        payload: DATA_LOAD_STATUS.error,
      });
      console.log(ex.message, "err");
      appInsightProps.statusCode = 0;
      appInsights.trackException({ error: ex.message, appInsightProps });
      return null;
    }
  };

export const onGetFormatsByClass =
  (className) =>
  async (dispatch) => {
    try {
      const tokenResponse = await userAuth.getUserToken(true);
      const tokenOneDrive = tokenResponse ? tokenResponse.accessToken : null;
      if (!tokenOneDrive) {
        dispatch({
          type: ON_TOKEN_FAIL,
          payload: tokenResponse,
        });
        return null;
      }

      const apiClient = getApiClient(tokenOneDrive);
      const response = await apiClient.get(
        `/api/DocumentManagement/get-docformatinfo?webUser=${encodeURIComponent(new AuthTeams().getEmail())}&className=${encodeURIComponent(className)}`,
      );

      return response?.status === 200 ? response.data : null;
    } catch (error) {
      return null;
    }
  };

function getDocClasses(classes) {
  const items = [];
  try {
    if (classes) {
      classes.map((item) => {
        items.push({
          id: item.docClass,
          code: `${item.docClass}`,
          name: `${item.docClass} - ${item.docName}`,
          viewRequired: `${item.viewRequired}`,
          formatRequired: `${item.formatMandatory}`,
          objConRequired: `${item.objectConnectionRequired}`,
          children: getDocFormats(
            item.formats,
            item.viewRequired,
            item.formatMandatory,
            item.objectConnectionRequired,
          ),
        });
      });
    }
  } catch (ex) {
    console.log(ex.message, "err");
  }
  return items;
}

function getDocFormats(
  formats,
  viewRequired,
  formatMandatory,
  objectConnectionRequired,
) {
  const items = [];
  if (formats) {
    formats.map((item) => {
      items.push({
        id: `${item.docClass}${item.formatSize}`,
        code: `${item.formatSize}`,
        name: `${item.formatSize} - ${item.formatSizeName}`,
        parent: `${item.docClass}`,
        viewRequired: viewRequired,
        formatRequired: `${formatMandatory}`,
        objConRequired: `${objectConnectionRequired}`,
      });
    });
  }
  return items;
}

function timeout(uploadFiles) {
  let fileSize = 0;
  try {
    if (!Array.isArray(uploadFiles)) return 0;
    uploadFiles.forEach((uploadFile) => {
      const size =
        uploadFile?.file?.size ??
        (typeof uploadFile?.size === "number" ? uploadFile.size : 0);
      if (size && fileSize < size) {
        fileSize = size;
      }
    });
    fileSize = (fileSize / 1000000) * 8; //bytes,Megabytes,Megabit
    let uploadSpeed = localStorage.getItem("ifsUploadSpeed");
    let timeOutOpload = (fileSize / uploadSpeed) * 1000 * 4; //seconds,miliseconds,overload
    return timeOutOpload;
  } catch (ex) {
    return 0;
  }
}
